<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver>
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field
                      :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                    >
                      <label>الاسم</label>
                      <md-input v-model="FullName"></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field
                      :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                    >
                      <label>رقم الملاك الوظيفي</label>
                      <md-input v-model="JobNumber"></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <model-list-select
                      :list="departments"
                      v-model="DepartmentId"
                      option-value="id"
                      option-text="name"
                      placeholder="يتبع لـ"
                    ></model-list-select>
                  </div>

                  <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field
                      :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                    >
                      <label>الرقم الوطني</label>
                      <md-input v-model="NationalNumber"></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field>
                      <label>تصنيف الفروع</label>
                      <md-select v-model="DepartmentClassificationsId">
                        <md-option
                          v-for="departmentClassification in departmentClassification"
                          v-bind:key="departmentClassification.id"
                          :value="departmentClassification.id"
                        >{{ departmentClassification.name }}</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <!-- <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field>
                      <label>تقرير الموظفين</label>
                      <md-select v-model="BankBranchId">
                        <md-option
                          v-for="BankBranch in BankBranch"
                          v-bind:key="BankBranch.key"
                          :value="BankBranch.key"
                          >{{ BankBranch.value }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>-->

                  <div v-if="searchE" class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field>
                      <label>نوع التوظيف</label>
                      <md-select v-model="JobType">
                        <md-option value="1">تعيين</md-option>
                        <md-option value="2">عقد</md-option>
                        <md-option value="3">ندب</md-option>
                        <md-option value="4">نقل</md-option>
                        <md-option value="5">عقد مصنف</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div v-if="searchE" class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field>
                      <label>المؤهلات العلمية</label>
                      <md-select v-model="ScientificDegreeId">
                        <md-option
                          v-for="scientificDegrees in scientificDegrees"
                          v-bind:key="scientificDegrees.key"
                          :value="scientificDegrees.key"
                        >{{ scientificDegrees.value }}</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div v-if="searchE" class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-datepicker v-model="StartingDateFrom">
                      <label class="mr-28">تاريخ المباشرة من</label>
                    </md-datepicker>
                  </div>

                  <div v-if="searchE" class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-datepicker v-model="StartingDateTo">
                      <label class="mr-28">تاريخ المباشرة الى</label>
                    </md-datepicker>
                  </div>

                  <div v-if="searchE" class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field>
                      <label>ترتيب النتائج</label>
                      <md-select v-model="SortBy">
                        <md-option value="0">ترتيب الأسماء تصاعديا</md-option>
                        <md-option value="1">ترتيب الأسماء تنازليا</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div v-if="searchE" class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field>
                      <label>إستحقاق الترقيات والعلاوة</label>
                      <md-select v-model="BonusDueDateFilterType">
                        <md-option value="1">موظفين اقترب استحقاقهم لعلاوة</md-option>
                        <md-option value="2">موظفين يستحقون علاوة</md-option>
                        <md-option value="3">موظفين يستحقون ترقية</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div v-if="searchE" class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field>
                      <label>نوع انتهاء الخدمة</label>
                      <md-select v-model="TypeOfEndService">
                        <md-option value="1">استقالة</md-option>
                        <md-option value="2">فصل من الخدمة</md-option>
                        <md-option value="3">تقاعد</md-option>
                        <md-option value="4">تقاعد اختياري</md-option>
                        <md-option value="5">وفاة</md-option>
                        <md-option value="6">انهاء ندب</md-option>
                        <md-option value="7">نقل</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div v-if="searchE" class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field>
                      <label>اظهار المقتربين من التقاعد</label>
                      <md-select v-model="MustRetireSoon">
                        <md-option value="true">نعم</md-option>
                        <md-option value="false">لا</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 mt-25">
                    <md-checkbox v-model="searchE">بحث متقدم</md-checkbox>
                  </div>

                  <div class="md-layout-item md-size-100 mt-25 center-content">
                    <md-button @click="Search" class="md-success btn_nanosoft">بحث</md-button>
                    <md-button @click="New" class="md-info btn_nanosoft">جديد</md-button>

                    <md-button @click="Clear" class="md-black btn_nanosoft">إفراغ الحقول</md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">البحث</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout flex-content-left">
            <div class="md-layout-item md-size-20">
              <md-table-toolbar>
                <md-field>
                  <label for="pages">عدد النتائج</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option value="25">25</md-option>
                    <md-option value="50">50</md-option>
                    <md-option value="75">75</md-option>
                    <md-option value="100">100</md-option>
                  </md-select>
                </md-field>
              </md-table-toolbar>
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="الرقم الوطني">
                <p @click="handleEdit(item)">
                  {{
                  item.personalInfo.nationalNumber
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="الإسم الرباعي">
                <p @click="handleEdit(item)">
                  {{
                  item.personalInfo.fullName
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="رقم الملاك الوظيفي">
                <p @click="handleEdit(item)">
                  {{
                  item.jobInfo.jobNumber
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="يتبع لـ">
                <p @click="handleEdit(item)">
                  {{
                  item.jobInfo.departmentName
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="الصفة الوظيفية">
                <p @click="handleEdit(item)">
                  {{
                  item.jobInfo.jobTitle
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="رقم الهاتف">
                <p @click="handleEdit(item)">
                  {{
                  item.personalInfo.phone
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="تاريخ الميلاد">
                <p @click="handleEdit(item)">
                  {{
                  convert(item.personalInfo.birthDate)
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="الدوام الرسمي">
                <p @click="handleEdit(item)">
                  {{
                  item.jobInfo.shiftName
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="الصفة">
                <p @click="handleEdit(item)">
                  {{
                  item.jobInfo.isManager == true ? 'مدير':'موظف عادي'
                  }}
                </p>
              </md-table-cell>

              <md-table-cell v-if="item.jobInfo.jobType == 1" md-label="نوع التوظيف">
                <p @click="handleEdit(item)">تعيين</p>
              </md-table-cell>

              <md-table-cell v-if="item.jobInfo.jobType == 2" md-label="نوع التوظيف">
                <p @click="handleEdit(item)">عقد</p>
              </md-table-cell>

              <md-table-cell v-if="item.jobInfo.jobType == 3" md-label="نوع التوظيف">
                <p @click="handleEdit(item)">ندب</p>
              </md-table-cell>

              <md-table-cell v-if="item.jobInfo.jobType == 4" md-label="نوع التوظيف">
                <p @click="handleEdit(item)">نقل</p>
              </md-table-cell>

              <md-table-cell v-if="item.jobInfo.jobType == 5" md-label="نوع التوظيف">
                <p @click="handleEdit(item)">عقد مصنف</p>
              </md-table-cell>

              <md-table-cell md-label="تاريخ المباشرة">
                <p @click="handleEdit(item)">
                  {{
                  convert(item.jobInfo.startingDate)
                  }}
                </p>
              </md-table-cell>

              <md-table-cell md-label="ساعات العمل الشهرية">
                <p @click="handleEdit(item)">
                  {{
                  item.financialInfo.totalWorktime
                  }}
                </p>
              </md-table-cell>

              <!-- <md-table-cell md-label="التفعيل بالبريد الالكتروني">{{
                item.jobTitle
              }}</md-table-cell>-->

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th v-for="item in footerTable" :key="item.name" class="md-table-head">
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import { ModelListSelect } from "vue-search-select";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
// import { SlideYDownTransition } from "vue2-transitions";
import state from "../../../../components/service/state";
import { extend } from "vee-validate";
import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
extend("required", required);
extend("numeric", numeric);
extend("regex", regex);
extend("confirmed", confirmed);
export default {
  async created() {
    await this.init();
    if (state.state == true) {
      this.FullName = state.FullName;
      this.NationalNumber = state.NationalNumber;
      this.JobNumber = state.JobNumber;
      this.DepartmentClassificationsId = state.DepartmentClassificationsId;
      this.DepartmentId = state.DepartmentId;
      this.JobType = state.JobType;
      this.ScientificDegreeId = state.ScientificDegreeId;
      this.StartingDateFrom = state.StartingDateFrom;
      this.StartingDateTo = state.StartingDateTo;
      this.SortBy = state.SortBy;
      this.BonusDueDateFilterType = state.BonusDueDateFilterType;
      this.TypeOfEndService = state.TypeOfEndService;
      this.MustRetireSoon = state.MustRetireSoon;
      this.pagination.perPage = state.perPage;
      this.pagination.currentPage = state.currentPage;
      this.Search();
    }
  },
  components: {
    Pagination,
    ModelListSelect
    // SlideYDownTransition,
  },
  computed: {
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      searchE: "",
      NationalNumber: "",
      FullName: "",
      JobNumber: "",
      DepartmentClassificationsId: "",
      DepartmentId: "",
      JobType: "",
      ScientificDegreeId: "",
      StartingDateFrom: "",
      StartingDateTo: "",
      SortBy: "0",
      BonusDueDateFilterType: "",
      PageSize: null,
      TypeOfEndService: "",
      MustRetireSoon: false,
      departments: [],
      departmentClassification: "",
      scientificDegrees: "",
      ///

      updateStatus: "",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      } catch (error) {}
    },
    async Search() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/hr/employees/filter?FullName=${
            this.FullName
          }&NationalNumber=${this.NationalNumber}&JobNumber=${
            this.JobNumber
          }&DepartmentClassificationsId=${
            this.DepartmentClassificationsId
          }&DepartmentId=${this.DepartmentId}&JobType=${
            this.JobType
          }&ScientificDegreeId=${this.ScientificDegreeId}&StartingDateFrom=${
            this.StartingDateFrom
          }&StartingDateTo=${this.StartingDateTo}&SortBy=${
            this.SortBy
          }&BonusDueDateFilterType=${
            this.BonusDueDateFilterType
          }&TypeOfEndService=${this.TypeOfEndService}&MustRetireSoon=${
            this.MustRetireSoon
          }&PageSize=${this.pagination.perPage}&currentPage=${
            this.pagination.currentPage
          }`,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );
        this.tableData = result.data.data.results;
        this.pagination.total = result.data.data.total;
        this.SaveState();
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
    SaveState() {
      state.state = true;
      state.FullName = this.FullName;
      state.NationalNumber = this.NationalNumber;
      state.JobNumber = this.JobNumber;
      state.DepartmentClassificationsId = this.DepartmentClassificationsId;
      state.DepartmentId = this.DepartmentId;
      state.JobType = this.JobType;
      state.ScientificDegreeId = this.ScientificDegreeId;
      state.StartingDateFrom = this.StartingDateFrom;
      state.StartingDateTo = this.StartingDateTo;
      state.SortBy = this.SortBy;
      state.BonusDueDateFilterType = this.BonusDueDateFilterType;
      state.TypeOfEndService = this.TypeOfEndService;
      state.MustRetireSoon = this.MustRetireSoon;
      state.perPage = this.pagination.perPage;
      state.currentPage = this.pagination.currentPage;
    },
    Clear() {
      state.state = false;
      this.FullName = "";
      this.NationalNumber = "";
      this.JobNumber = "";
      this.DepartmentClassificationsId = "";
      this.DepartmentId = "";
      this.JobType = "";
      this.ScientificDegreeId = "";
      this.StartingDateFrom = "";
      this.StartingDateTo = "";
      this.SortBy = "";
      this.BonusDueDateFilterType = "";
      this.TypeOfEndService = "";
      this.MustRetireSoon = "";
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    New() {
      this.$router.push("employee/info/new");
    },
    handleEdit(item) {
      this.$router.push("employee/info/" + item.personalInfo.id);
    },
    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/hr/employees/new`, {
          headers: { Authorization: "Bearer " + token }
        });
        this.departments = result.data.data.departments;
        this.departmentClassification =
          result.data.data.departmentClassifications;
        this.scientificDegrees = result.data.data.scientificDegrees;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "تعم",
        cancelButtonText: "لا",
        buttonsStyling: false
      }).then(async result => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/hr/employees/${item.personalInfo.id}`,
              {
                headers: { Authorization: "Bearer " + token }
              }
            );
            this.deleteRow(item);
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            let result =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ];
            return this.notifyVue("top", "center", "danger", result[0]);
          }
        }
      });
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3
    });
  },
  watch: {
    "pagination.perPage"() {
      this.Search();
    },
    "pagination.currentPage"() {
      this.Search();
    }
  }
};
</script>

<style scoped>
.mt-37 {
  margin-top: 37px;
}
</style>
